export default "__VITE_ASSET__b5bf864c__"